import { render, staticRenderFns } from "./manage-section.vue?vue&type=template&id=0a999869&scoped=true&"
import script from "./manage-section.vue?vue&type=script&lang=js&"
export * from "./manage-section.vue?vue&type=script&lang=js&"
import style0 from "./manage-section.vue?vue&type=style&index=0&id=0a999869&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a999869",
  null
  
)

export default component.exports